export default __webpack_public_path__ + "static/why-gravitywell-meeting-7f23de204486ae9315096f3c00d23c20.jpg";